"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unlinkProjects = exports.linkProjects = exports.linkFiles = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const ActionTypes = require("../../actionTypes/congrid/link");
const Actions = require("../../actions/congrid/link");
const ProjectsActions = require("../../actions/congrid/projects");
const errorHandling_1 = require("../../utils/errorHandling");
function linkFiles(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.LINK_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        body: action.payload,
        url: `${baseUrl}api/congrid/link`
    }).pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.of)(Actions.linkSuccess())), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.linkFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.linkFiles = linkFiles;
function linkProjects(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.LINK_PROJECT_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        body: action.payload,
        url: `${baseUrl}api/congrid/project/link`
    }).pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.of)(...[
        Actions.linkProjectSuccess(),
        ProjectsActions.fetchRequest(action.payload.projectId)
    ])), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.linkProjectFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.linkProjects = linkProjects;
function unlinkProjects(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.UNLINK_PROJECT_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'DELETE',
        body: { congridProjectIds: action.payload.congridProjectIds },
        url: `${baseUrl}api/congrid/project/${action.payload.projectId}`
    }).pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.of)(...[
        Actions.unlinkProjectSuccess(),
        ProjectsActions.fetchRequest(action.payload.projectId)
    ])), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.unlinkProjectFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.unlinkProjects = unlinkProjects;
//# sourceMappingURL=link.js.map